import * as React from "react"

interface Props {
    types: string[]
}

export default class TypeIndicator extends React.Component<Props> {
    render(): JSX.Element {
        const { types } = this.props
        let headerTopDesign = <></>
        if (!!types) {
            types.forEach((type) => {
                switch (type) {
                    case "Smartlist":
                        headerTopDesign = this.getListDesign(null, "bg-primary")
                        break
                    case "List":
                        headerTopDesign = this.getListDesign(
                            "bg-dark",
                            "bg-darker",
                        )
                        break
                    case "Dashboard":
                        headerTopDesign = this.getWorkspaceDesign("#00b3fd")
                        break
                    case "Workspace":
                        headerTopDesign = this.getWorkspaceDesign("#dcdcdc")
                        break
                }
            })
        }
        return headerTopDesign
    }

    getWorkspaceDesign = (color: string): JSX.Element => (
        <svg
            style={{ color }}
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="30px"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
        >
            <defs>
                <linearGradient id="grad1" x1="0%" y1="100%" x2="0%" y2="0%">
                    <stop
                        offset="0%"
                        style={{ stopColor: "currentColor", stopOpacity: 1 }}
                    />
                    <stop
                        offset="50%"
                        style={{ stopColor: "currentColor", stopOpacity: 0.5 }}
                    />
                    <stop
                        offset="100%"
                        style={{ stopColor: "currentColor", stopOpacity: 0 }}
                    />
                </linearGradient>
            </defs>
            <polygon fill="url(#grad1)" points="3,0 97,0 100,50 0,50" />
            <polygon
                fill="currentColor"
                opacity="0.75"
                points="100,50 100,100 0,100 0,50"
            />
        </svg>
    )

    getListDesign = (
        firstColor: string | null,
        secondColor: string,
    ): JSX.Element => (
        <div className="theme-layers bg-darkest">
            {!!firstColor && <span className={firstColor}></span>}
            <span className={secondColor}></span>
        </div>
    )
}
